module.exports = __webpack_public_path__ + "assets/60abae8753bc7c7a5ba291ce02ea2e0d.png";